var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManifestFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.194,
  d: "m13.43 9.946-5.969.01"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  d: "M2.984 3.184c0-.66.535-1.194 1.194-1.194h10.313c.279 0 .55.098.764.276l2.652 2.21 2.555 2.13c.273.227.43.563.43.917v13.17c0 .66-.534 1.194-1.194 1.194H4.178c-.66 0-1.194-.534-1.194-1.194z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.194,
  d: "M16.415 17.908H7.461M16.415 13.928H7.461"
})));
export default SvgManifestFile;